import { observable } from 'mobx'
import { ResourcesRequest } from './ResourcesRequest'

class ResourcesStore {
  @observable items = []
  @observable shareList = []
  @observable breadCrumb = []
  @observable currentFolderId = ''
  @observable isLoading = false

  @observable sortInfo = {
    sortedInfo: null,
  }

  @observable keyword = null

  search = async () => {
    this.isLoading = true

    let param = {
      id: this.currentFolderId,
      keyword: this.keyword,
    }

    const response = await ResourcesRequest.search(param)
    this.items = response.data?.data
    this.breadCrumb = response.data?.breadcrumb || []

    this.isLoading = false
  }

  searchShareList = async () => {
    // this.isLoading = true

    let param = {
      keyword: this.keyword,
    }

    const response = await ResourcesRequest.shareList(param)
    this.shareList = response.data?.data
    // this.breadCrumb = response.data?.breadcrumb || []

    // this.isLoading = false
  }

  delete = async id => {
    this.isLoading = true

    await ResourcesRequest.delete(id)

    await this.search()
  }

  published = async data => {
    this.isLoading = true

    await ResourcesRequest.published(data)

    await this.search()
  }

  clear = () => {
    this.items = []
    this.breadCrumb = []
    this.currentFolderId = ''
    this.isLoading = false
  }

  clearShareList = () => {
    this.shareList = []
  }
}

export default new ResourcesStore()
